module.exports = __webpack_public_path__ + "img/Weapon_228.4daa9a94.png";